import React from 'react';
import {
  Description as DocumentIcon,
  Business as EntityIcon,
  Gavel as DefendantIcon,
  Person as PersonIcon,
  Info as InfoIcon,
  Notes as NoteIcon,
  Assignment as TaskIcon,
  Email as EmailIcon,
} from '@mui/icons-material';

// Event type color mapping - more subtle
export const EVENT_TYPE_COLORS: { [key: string]: string } = {
  'log_entry': '#2196F3',
  'entity_added': '#4CAF50',
  'entity_removed': '#F44336',
  'entities_bulk_added': '#66BB6A',
  'entities_bulk_removed': '#EF5350',
  'defendant_added': '#FF9800',
  'defendant_removed': '#E64A19',
  'defendants_bulk_added': '#FFB74D',
  'defendants_bulk_removed': '#FF7043',
  'document_generated': '#9C27B0',
  'document_bundle_generated': '#BA68C8',
  'document_uploaded': '#7B1FA2',
  'document_edited': '#AB47BC',
  'document_removed': '#6A1B9A',
  'status_changed': '#00BCD4',
  'case_created': '#009688',
  'counsel_added': '#3F51B5',
  'counsel_removed': '#303F9F',
  'team_member_added': '#5C6BC0',
  'team_member_removed': '#3949AB',
  'task_created': '#FF6F00',
  'task_assigned': '#FFA726',
  'task_completed': '#66BB6A',
  'task_status_changed': '#FFB300',
  'email_thread_added': '#00ACC1',
  'email_received': '#0288D1',
  'email_sent': '#0277BD',
};

// Event type icon mapping
export const getEventIcon = (eventType: string, size: 'small' | 'inherit' = 'small') => {
  const fontSize = size;
  if (eventType.includes('entity') || eventType.includes('entities')) {
    return <EntityIcon fontSize={fontSize} />;
  } else if (eventType.includes('defendant')) {
    return <DefendantIcon fontSize={fontSize} />;
  } else if (eventType.includes('document')) {
    return <DocumentIcon fontSize={fontSize} />;
  } else if (eventType.includes('counsel') || eventType.includes('team_member')) {
    return <PersonIcon fontSize={fontSize} />;
  } else if (eventType === 'log_entry') {
    return <NoteIcon fontSize={fontSize} />;
  } else if (eventType.includes('task')) {
    return <TaskIcon fontSize={fontSize} />;
  } else if (eventType.includes('email')) {
    return <EmailIcon fontSize={fontSize} />;
  }
  return <InfoIcon fontSize={fontSize} />;
};
